// ** Gatsby
import { GatsbyImage } from "gatsby-plugin-image"

// ** Custom Components
import Box from "../Box"
import Container from "../Container"
import { serializers } from "../Serializers"
import Text from "../Text"

// ** 3rd Party Library
import { PortableText } from "@portabletext/react"

const SectionFeaturedProfile = ({ section }: any) => {
  const { listItems } = section
  return (
    <Container fullWidthOnMobile={false} constrainedToBreakPoint>
      <Box className="gap-0 rounded-[20px] mt-4 md:mt-8 isolate shadow-md flex w-full flex-col md:flex-row">
        <Box className="w-full h-[200px] md:h-auto flex rounded-tl-[20px] rounded-tr-[20px] md:rounded-tr-none md:rounded-bl-[20px] flex-col md:flex-1 p-4 bg-orange-400">
          <Box className="flex-1">
            <GatsbyImage
              image={listItems[0]?.Image?.asset?.gatsbyImageData}
              alt={listItems[0]?.Image?.asset?.altText || ""}
              className="w-full h-full"
              objectFit="contain"
            />
          </Box>
          <Box className="basis-5/12 md:basis-3/12">
            <Text
              variant="large"
              className="text-blue-500 text-center md:text-left mt-4 lg:mt-8"
            >
              {listItems[0]?.value}
            </Text>
          </Box>
        </Box>
        <Box className="w-full md:rounded-tr-[20px] rounded-bl-[20px] rounded-br-[20px] md:rounded-bl-none md:basis-8/12 bg-blue-400 relative">
          <Box className="p-4 [&>h2]:text-center [&>h2]:lg:text-left [&>h2]:text-white [&>h2]:font-bold [&>h2]:mb-0 [&>p]:text-white [&>p]:text-center [&>p]:lg:text-left [&>h6]:text-white [&>h6]:text-center [&>h6]:lg:text-left [&>h6]:font-normal [&>h6]:mb-2 [&>h6>a]:text-white [&>h6>a]:font-bold">
            <PortableText
              components={serializers}
              value={listItems[1]?._rawContent}
            />
          </Box>

          <Box className="md:absolute flex bottom-0 md:-right-10 lg:right-0 w-full md:w-1/2 h-[250px] md:h-[325px] lg:h-[450px] z-50">
            <GatsbyImage
              image={listItems[1]?.Image?.asset?.gatsbyImageData}
              alt={listItems[1]?.Image?.asset?.altText || "featured profile"}
              className="w-full h-full"
              objectFit="contain"
            />
          </Box>
        </Box>
      </Box>
    </Container>
  )
}

export default SectionFeaturedProfile
